const myStyle = theme => ({
  navMargin: {
    marginTop: "64px"
  },

  drawer: {
    width: 321,
    overflow: "hidden",
    height: "100vh",
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    }
  }
});

export default myStyle;
